import { Component, Input } from '@angular/core';

@Component({
    selector: 'toro-i3-detail-card',
    templateUrl: './i3-detail-card.component.html',
    styleUrls: ['./i3-detail-card.component.less']
})
export class I3DetailCardComponent {

    @Input() title: string;
    @Input() value: string;

}

